export const InsureAssistPerformanceStyles = {
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    paddingY: "1rem",
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },

  dateFieldsContianer: {
    display: "flex",
    alignSelf: "flex-end",
    gap: 2,
  },
  metricsContainer: {
    display: "flex",
    gap: 3,
    width: "100%",
    paddingY: "1rem",
  },
  averageTokenUsageContainer: {
    width: "100%",
    boxShadow: 1,
    padding: 2,
    borderRadius: 2,
  },
  noDataContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
};
